import { createHeaders } from "../services/ApiCallHeaderService";

export default async function RetrieveCoCResult(
  policyNumber,
  distributorNo,
  accessToken,
  oktaIdToken
) {
  const baseUrl = document.getElementById("serviceBaseUrl")?.value || "";
  const url =
    baseUrl +
    "/api/TAL/PolicyDetails/GetCocFromOds?policyNumber=" +
    policyNumber +
    "&distributorNo=" +
    distributorNo;
  //const url = "https://adviser-local-sitecore10.delivery.lan" + "/api/TAL/PolicyDetails/GetCocFromOds?policyNumber=" + policyNumber + "&distributorNo=" + distributorNo; // note: local testing

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: createHeaders(accessToken, oktaIdToken),
    });

    if (!response) {
      throw Error("No response");
    } else if (!response.ok) {
      throw Error(response.statusText);
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.log("cocresponse", error);

    console.log(error);
  }
}
